module.exports = __webpack_public_path__ + "img/bos-home.5c2c66eb.jpg";